// Angular
import { Component, Input, OnInit, AfterContentInit, ChangeDetectorRef } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthServiceCustom } from 'src/app/core/auth/authServiceCustom';


@Component({
  selector: 'kt-user-profile-side',
  templateUrl: './user-profile-side.component.html',
})
export class UserProfileSideComponent implements OnInit {


  @Input() avatar = true;
  @Input() greeting = true;
  @Input() badge: boolean;
  @Input() icon: boolean;
  @Input() userName: string;
  @Input() name: string;

  content = false;

  constructor(
    private cdRef: ChangeDetectorRef) {

  }
  ngOnInit(): void {
    this.content = true;
  }

  logout() {
  }

}
